import type { InputHTMLAttributes, ReactNode } from "react";
import { useId } from "react";
import { cn } from "../cn";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: ReactNode;
  hint?: ReactNode;
}

/** A labelled checkbox. The label is clickable, because a 16px hit target is not. */
export function Checkbox({ label, hint, className, id, ...props }: CheckboxProps) {
  const generated = useId();
  const boxId = id ?? generated;
  const hintId = `${boxId}-hint`;

  return (
    <div className="flex items-start gap-2.5">
      <input
        id={boxId}
        type="checkbox"
        aria-describedby={hint ? hintId : undefined}
        className={cn(
          "mt-0.5 size-4 rounded border-rule text-accent-text accent-accent-text",
          "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent",
          className,
        )}
        {...props}
      />
      <div className="flex flex-col gap-0.5">
        {label ? (
          <label htmlFor={boxId} className="font-sans text-ui text-ink">
            {label}
          </label>
        ) : null}
        {hint ? (
          <p id={hintId} className="text-meta text-ink-3">
            {hint}
          </p>
        ) : null}
      </div>
    </div>
  );
}
